// @flow weak
// because of current incompatibility with string templates; need to fix

import Formatic from 'formatic';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import RandomPhraseSpinner from 'app/common/components/RandomPhraseSpinner';
import ServiceUtils from 'app/service/ServiceUtils';
import { get, possessive } from 'app/common/CommonUtils';

const ANY_PHRASE_TYPE = 'any';
const CHOICE_PHRASE_TYPE = 'choice';
const SERVICE_PHRASE_TYPE = 'service';
const FIELDS_PHRASE_TYPE = 'fields';
const FIELDS_SERVICE_PHRASE_TYPE = 'fields-service';
const FIELDS_SERVICES_PHRASE_TYPE = 'fiedls-services';

const loadingPhraseSets = {
  // These phrases work for anything.
  [ANY_PHRASE_TYPE]: [
    [
      'Releasing the carrier pigeons',
      'Waiting for the pigeons to return',
      'Still waiting on the pigeons (stick with us; can take a few minutes)',
    ],
  ],
  // These phrases work for dropdowns.
  [CHOICE_PHRASE_TYPE]: [
    [
      'Loading choices',
      'Still loading choices',
      'Still still loading choices (hang tight, can take a minute)',
    ],
  ],
  // These phrases work for anything with a single service.
  [SERVICE_PHRASE_TYPE]: [
    [
      props =>
        `Knocking on ${possessive(ServiceUtils.name(props.service))} door`,
      props => `Waiting for ${ServiceUtils.name(props.service)} to answer`,
      props =>
        `Still waiting on ${ServiceUtils.name(
          props.service
        )} (stick with us; can take a few minutes)`,
    ],
    [
      'Commence thumb twiddling',
      props => `${ServiceUtils.name(props.service)} is sure taking their time`,
      'Still twiddling thumbs (stick with us; can take a few minutes)',
    ],
    [
      props => `Giving ${ServiceUtils.name(props.service)} a call`,
      props => `Ring ring ring! Pick up ${ServiceUtils.name(props.service)}!`,
      'Still waiting for an answer (stick with us; can take a few minutes)',
    ],
  ],
  // These phrases work for insert fields.
  [FIELDS_PHRASE_TYPE]: [
    [
      'Loading fields',
      'Still loading fields',
      'Still still loading fields (hang tight, can take a minute)',
    ],
  ],
  // These phrases work for insert fields with one service.
  [FIELDS_SERVICE_PHRASE_TYPE]: [
    [
      props =>
        `Loading fields from ${possessive(ServiceUtils.name(props.service))}`,
      props => `Still loading fields from ${ServiceUtils.name(props.service)}`,
      props =>
        `Still still loading fields from ${ServiceUtils.name(
          props.service
        )} (hang tight, can take a minute)`,
    ],
  ],
  // These phrases work for insert fields with more than one service.
  [FIELDS_SERVICES_PHRASE_TYPE]: [
    [
      props => `Loading fields from ${props.serviceCount} apps`,
      props => `Still loading fields from ${props.serviceCount} apps`,
      props =>
        `Still still loading fields from ${props.serviceCount} apps (hang tight, can take a minute)`,
    ],
    [
      props => `Asking ${props.serviceCount} apps for fields`,
      props => `Asking those ${props.serviceCount} apps really nicely`,
      'Saying pretty please with sugar on top (stick with us; can take a few minutes)',
    ],
  ],
};

const LoadingChoice = createReactClass({
  mixins: [PureRenderMixin, Formatic.availableMixins.helper],

  displayName: 'LoadingChoice',

  render: function() {
    return this.renderWithConfig();
  },

  renderDefault: function() {
    const { field } = this.props;
    const meta = get(field, ['meta'], {});
    let service;
    let serviceCount = 0;
    const replaceChoices = field.replaceChoices;
    const isCustomValue = field.isCustomValue;

    const phraseTypes = [];

    phraseTypes.push(ANY_PHRASE_TYPE);

    if (!replaceChoices && !isCustomValue) {
      phraseTypes.push(CHOICE_PHRASE_TYPE);
      service = meta.service;
    } else {
      phraseTypes.push(FIELDS_PHRASE_TYPE);
      const { flow, stepIndex, services } = meta;
      // Could be many previous services. Let's see.
      if (flow && flow.nodes && stepIndex && services) {
        const steps = flow.steps || [];
        const prevSteps = steps.slice(0, stepIndex);
        const prevServices = _.uniq(
          prevSteps
            .map(step => get(flow.nodes[step.nodeId], ['selected_api']))
            .filter(Boolean)
        )
          .map(selectedApi => services[selectedApi])
          .filter(Boolean);
        // If it's just one previous service, use that.
        if (prevServices.length === 1) {
          service = prevServices[0];
          phraseTypes.push(FIELDS_SERVICE_PHRASE_TYPE);
        } else if (prevServices.length > 1) {
          serviceCount = prevServices.length;
          phraseTypes.push(FIELDS_SERVICES_PHRASE_TYPE);
        }
      }
    }

    if (service) {
      phraseTypes.push(SERVICE_PHRASE_TYPE);
    }

    const phrases = _.flatten(phraseTypes.map(type => loadingPhraseSets[type]));

    return (
      <span className="loading-choices">
        <RandomPhraseSpinner
          phrases={phrases}
          service={service}
          serviceCount={serviceCount}
        />
      </span>
    );
  },
});

export default LoadingChoice;
